// src/app/modules/Reports/components/GenerateReportModal.jsx
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as actions from '../../../Dashbord/_redux/dashboard/Actions';
import { X, FileText } from 'lucide-react';
import './GenerateReportModal.scss';

export function GenerateReportModal({ show, onHide, organizationId, onSuccess }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    report_type: 'custom',
    start_date: '',
    end_date: '',
    include_incidents: true,
    include_visitors: true,
    include_threats: true,
    include_access_logs: true,
  });

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      await dispatch(actions.addData('generate_report', {
        ...formData,
        organization_id: organizationId
      }));
      
      onHide();
      if (onSuccess) onSuccess();
      
      setFormData({
        report_type: 'custom',
        start_date: '',
        end_date: '',
        include_incidents: true,
        include_visitors: true,
        include_threats: true,
        include_access_logs: true,
      });
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="generate-report-modal">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Generate Custom Report</h5>
          <button className="close" onClick={onHide} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Report Type *</label>
              <select
                name="report_type"
                className="form-control"
                value={formData.report_type}
                onChange={handleChange}
                required
              >
                <option value="custom">Custom Report</option>
                <option value="security">Security Overview</option>
                <option value="incident">Incident Summary</option>
                <option value="visitor">Visitor Analytics</option>
                <option value="threat">Threat Analysis</option>
              </select>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Start Date *</label>
                  <input
                    type="date"
                    name="start_date"
                    className="form-control"
                    value={formData.start_date}
                    onChange={handleChange}
                    max={new Date().toISOString().split('T')[0]}
                    required
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>End Date *</label>
                  <input
                    type="date"
                    name="end_date"
                    className="form-control"
                    value={formData.end_date}
                    onChange={handleChange}
                    max={new Date().toISOString().split('T')[0]}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="mb-3">Include in Report:</label>
              
              <div className="form-check mb-2">
                <input
                  type="checkbox"
                  name="include_incidents"
                  className="form-check-input"
                  checked={formData.include_incidents}
                  onChange={handleChange}
                  id="include_incidents"
                />
                <label className="form-check-label" htmlFor="include_incidents">
                  Incidents & Emergency Responses
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  type="checkbox"
                  name="include_visitors"
                  className="form-check-input"
                  checked={formData.include_visitors}
                  onChange={handleChange}
                  id="include_visitors"
                />
                <label className="form-check-label" htmlFor="include_visitors">
                  Visitor Analytics & Access Patterns
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  type="checkbox"
                  name="include_threats"
                  className="form-check-input"
                  checked={formData.include_threats}
                  onChange={handleChange}
                  id="include_threats"
                />
                <label className="form-check-label" htmlFor="include_threats">
                  Threat Alerts & Blacklist Activity
                </label>
              </div>

              <div className="form-check">
                <input
                  type="checkbox"
                  name="include_access_logs"
                  className="form-check-input"
                  checked={formData.include_access_logs}
                  onChange={handleChange}
                  id="include_access_logs"
                />
                <label className="form-check-label" htmlFor="include_access_logs">
                  Access Logs & Code Usage
                </label>
              </div>
            </div>

            <div className="alert alert-info">
              <strong>Note:</strong> Report generation may take a few minutes depending on the date range and data volume.
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={onHide} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2"></span>
                  Generating...
                </>
              ) : (
                <>
                  <FileText size={16} className="mr-2" />
                  Generate Report
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}